export default __webpack_public_path__ + "static/media/icon-facebook.4dd566b6.svg";